import React from "react";
import { Modal, ModalContent, ModalBody, Image } from "@heroui/react";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import ViewResultIcon1 from "../../../images/icon/view-result-icon-1.png";
import ViewResultIcon2 from "../../../images/icon/view-result-icon-2.png";
import ViewResultIcon3 from "../../../images/icon/view-result-icon-3.png";
import ViewResultIcon4 from "../../../images/icon/view-result-icon-4.png";

dayjs.extend(utc);

const ViewModalPopup = ({ isOpen, onOpenChange, data }) => {
  const votingPercentage = (count) => {
    const total = Number(data?.total_votes) || 0;
    return total > 0 ? ((count / total) * 100).toFixed(2) : 0;
  };

  return (
    <Modal
      isOpen={isOpen}
      onOpenChange={onOpenChange}
      size="sm"
      scrollBehavior="inside"
      placement="center"
    >
      <ModalContent className="max-h-[90vh] overflow-y-auto rounded-2xl">
        <ModalBody className="py-6 px-4 md:px-6 gap-5 overflow-y-auto">
          {/* Proposal Name */}
          <div className="pb-5 border-b border-dashed border-[#C2C2C2]">
            <div className="flex gap-2.5 items-start">
              <Image
                src={ViewResultIcon1}
                alt="icon"
                className="w-6 h-6"
                radius="none"
              />
              <p className="m-0 text-base text-black">
                <span className="font-medium">Proposal:</span>{" "}
                {data?.name || "N/A"}
              </p>
            </div>
          </div>

          {/* Voting Info */}
          <div className="flex flex-col gap-2.5 pb-5 border-b border-dashed border-[#C2C2C2]">
            <div className="flex gap-2.5 items-center">
              <Image
                src={ViewResultIcon2}
                alt="icon"
                className="w-6 h-6"
                radius="none"
              />
              <h2 className="m-0 text-base text-black font-normal">
                <span className="font-medium">Voting Ended:</span>{" "}
                {data?.end_date
                  ? dayjs.utc(data.end_date).format("MMM D, YYYY")
                  : "N/A"}
              </h2>
            </div>

            <div className="flex gap-2.5 items-center">
              <Image
                src={ViewResultIcon3}
                alt="icon"
                className="w-6 h-6"
                radius="none"
              />
              <p className="m-0 text-base text-black font-normal">
                <span className="font-medium">Total Votes:</span>{" "}
                {data?.total_votes || 0}
              </p>
            </div>
          </div>

          {/* Voting Breakdown */}
          <div className="flex flex-col gap-2.5">
            <div className="flex gap-2.5 items-center">
              <Image
                src={ViewResultIcon4}
                alt="icon"
                className="w-6 h-6"
                radius="none"
              />
              <h6 className="m-0 text-base font-medium text-black">
                Voting Breakdown:
              </h6>
            </div>

            {Array.isArray(data?.results) && data.results.length > 0 ? (
              data.results.map((item, index) => (
                <div key={index} className="ml-[2.125rem] flex flex-col gap-1">
                  <div className="flex justify-between text-sm text-black">
                    <span>{item?.name}</span>
                    <span>{votingPercentage(item?.total_votes)}%</span>
                  </div>
                  <div className="w-full bg-gray-200 h-2 rounded">
                    <div
                      className="bg-blue-500 h-2 rounded"
                      style={{
                        width: `${votingPercentage(item?.total_votes)}%`
                      }}
                    />
                  </div>
                  <p className="text-xs text-gray-500">
                    ({item?.total_votes}{" "}
                    {item?.total_votes > 1 ? "votes" : "vote"})
                  </p>
                </div>
              ))
            ) : (
              <p className="ml-[2.125rem] text-sm text-gray-500">
                No results available
              </p>
            )}
          </div>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};

export default ViewModalPopup;
